import React, { useEffect, useState } from 'react';
import Router from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from '../../../hooks';
import { getViewMode } from 'store/auth';
import classnames from 'classnames';
import Link from 'next/link';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import styles from 'styles/Layout.module.scss';
import { useUserUnread } from 'hooks/messages';
import {
  getCartCount,
  getLoggedCartCount,
  getWishListCount,
  getFavouriteCount,
} from 'store/cart';
import { getColor, getColorText, getColorMenu } from 'store/settings';

const Header = (props) => {
  const { chatClick, wishlistClick, cartClick } = props;
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const viewMode = useSelector(getViewMode);
  const unreadMessage = useUserUnread();
  const user = useUser();
  const cartLoggedValue = useSelector(getLoggedCartCount);
  const wishListLoggedCount = useSelector(getWishListCount);
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const menuColor = useSelector(getColorMenu);
  return (
    <>
      {/* {user?._id && (
        <div
          className={classnames(
            'cursor-pointer',
            'chat-icon-res',
            'header__nav-link',
            'header-icon',
            styles['header-icon'],
          )}
        >
          <span>
            <div
              className="header-Learning"
              style={{
                '--menu-bg-clr': menuColor,
                color: Router?.pathname === '/messages' ? menuColor : '',
              }}
              onClick={chatClick}
            >
              <ChatBubbleOutlineOutlinedIcon />

              {(!user._id || unreadMessage > 0) && (
                <span
                  className={classnames(
                    'w3-badge',
                    'card_badge',
                    styles['card_badge'],
                  )}
                  style={{
                    backgroundColor: `${colorStatus}`,
                    color: `${colorTextStatus}`,
                  }}
                >
                  {unreadMessage}
                </span>
              )}
            </div>
          </span>
        </div>
      )} */}
      {/* Mobile Responsive */}
      {/* {user?._id && (
        <div
          className={classnames(
            'cursor-pointer',
            'chat-icon-mobile',
            'header__nav-link',
            'header-icon',
            'chat-icon-top',
            styles['header-icon'],
          )}
        >
          <div className="chat-icon-res chat-icon-mobile">
            <span>
              <div
                className="header-item"
                style={{
                  '--menu-bg-clr': menuColor,
                  color: Router?.pathname === '/messages' ? menuColor : '',
                }}
                onClick={chatClick}
              >
                <ChatBubbleOutlineOutlinedIcon style={{ fontSize: 16 }} />

                <span className="chat-icon">Chats</span>
                {(!user._id || unreadMessage > 0) && (
                  <span
                    className="w3-badge w3-gray"
                    style={{
                      height: 'auto',
                      borderRadius: '30px',
                      width: 'auto',
                      display: 'initial',
                      padding: '2px 5px',
                      backgroundColor: '#C8C8C8 !important',
                      fontSize: '10px',
                      marginLeft: '10px',
                    }}
                  >
                    {unreadMessage}
                  </span>
                )}
              </div>
            </span>
          </div>
        </div>
      )} */}
      {viewMode === 'LEARNER' && metaData?.cmsHomePage && (
        <>
          <div
            className=" cursor-pointer
                      header__nav-link
                      chat-icon-res"
          >
            <span>
              <div
                className="header-Learning"
                style={{
                  '--menu-bg-clr': menuColor,
                  color:
                    Router?.pathname === '/homes/cart/wishList' ||
                    Router?.pathname === '/lms-user/cart/wishList'
                      ? menuColor
                      : '',
                }}
                onClick={wishlistClick}
              >
                <FavoriteBorderOutlinedIcon />
                {wishListLoggedCount > 0 && (
                  <span
                    className={classnames(
                      'w3-badge',
                      'card_badge',
                      styles['card_badge'],
                    )}
                    style={{
                      backgroundColor: `${colorStatus}`,
                      color: `${colorTextStatus}`,
                    }}
                  >
                    {wishListLoggedCount}{' '}
                  </span>
                )}
              </div>
            </span>
          </div>
          {/* Mobile Resposonsive */}
          <div className="cursor-pointer header__nav-link chat-icon-mobile wishlist-icon">
            <span>
              <div
                className="header-item"
                style={{
                  '--menu-bg-clr': menuColor,
                  color:
                    Router?.pathname === '/homes/cart/wishList' ||
                    Router?.pathname === '/lms-user/cart/wishList'
                      ? menuColor
                      : '',
                }}
                onClick={wishlistClick}
              >
                <FavoriteBorderOutlinedIcon style={{ fontSize: 16 }} />

                <span className="chat-icon ">Wish Lists</span>
                {wishListLoggedCount > 0 && (
                  <span
                    className="w3-badge w3-gray"
                    style={{
                      height: 'auto',
                      borderRadius: '30px',
                      width: 'auto',
                      display: 'initial',
                      padding: '2px 5px',
                      backgroundColor: '#C8C8C8 !important',
                      fontSize: '10px',
                      marginLeft: '10px',
                    }}
                  >
                    {wishListLoggedCount}{' '}
                  </span>
                )}
              </div>
            </span>
          </div>
          {/* )} */}
          <div className="cursor-pointer header__nav-link chat-icon-res">
            <span>
              <div
                className="header-Learning"
                style={{
                  '--menu-bg-clr': menuColor,
                  color:
                    Router?.pathname === '/homes/cart' ||
                    Router?.pathname === '/lms-user/cart'
                      ? menuColor
                      : '',
                }}
                onClick={cartClick}
              >
                <ShoppingCartOutlinedIcon />

                {cartLoggedValue > 0 && (
                  <span
                    className={classnames(
                      'w3-badge',
                      'card_badge',
                      styles['card_badge'],
                    )}
                    style={{
                      backgroundColor: `${colorStatus}`,
                      color: `${colorTextStatus}`,
                    }}
                  >
                    {cartLoggedValue}
                  </span>
                )}
              </div>
            </span>
          </div>
          {/* Mobile Responsive */}
          <div className="cursor-pointer header__nav-link chat-icon-mobile">
            <span>
              <div
                className="header-item"
                style={{
                  '--menu-bg-clr': menuColor,
                  color:
                    Router?.pathname === '/homes/cart' ||
                    Router?.pathname === '/lms-user/cart'
                      ? menuColor
                      : '',
                }}
                onClick={cartClick}
              >
                <ShoppingCartOutlinedIcon style={{ fontSize: 16 }} />

                <span className="chat-icon">Cart</span>
                {cartLoggedValue > 0 && (
                  <span
                    className="w3-badge w3-gray"
                    style={{
                      height: 'auto',
                      borderRadius: '30px',
                      width: 'auto',
                      display: 'initial',
                      padding: '2px 5px',
                      backgroundColor: '#C8C8C8 !important',
                      fontSize: '10px',
                      marginLeft: '10px',
                    }}
                  >
                    {cartLoggedValue}
                  </span>
                )}
              </div>
            </span>
          </div>
        </>
      )}
    </>
  );
};

export default Header;
